import { useState } from 'react';
import { useForm } from 'react-hook-form';
import CheckboxInput from '../CheckboxInput';
import RangeInput from "./RangeInput"

export default function RoomFilter({handleChange, areaFilter, priceFilter, rooms, type}) {
    const [price, setPrice] = useState(0);
    const [square, setSquare] = useState(0);
    const { register, handleSubmit } = useForm();

    const onChange = () => {
        handleSubmit(handleChange)()
    }

    const getLabel = (rooms, type) => {
        if (rooms == 0) {
            if (type === "office") {
                return "Оф.";
            } else if (type === "parking") {
                return "Парк.";
            } else if (type === "storeroom") {
                return "Клад.";
            }
        }

        return rooms == 100 ? "Ст" : rooms;
    }

    const getTitle = () => {
      if (type === 'office') return 'Доступные офисы';
      if (type === 'parking') return 'Доступные парковки';
      if (type === 'storeroom') return 'Доступные кладовки';
      return "Выберите количество комнат";
    }
    const title = getTitle()

    return (
        <form className="room__filter-box show" onChange={onChange}>
            <div className="filter-room">
                <div className="filter-room__name">{title}</div>
                <div className="filter-room__box">
                    { rooms?.map(({rooms, countFree}) => {
                        return rooms &&
                            <CheckboxInput
                                register={register}
                                value={getLabel(rooms, type)}
                                status={countFree ? `${countFree} шт.` : "Продано"}
                                name={`room[${rooms}]`}
                                disabled={!countFree}
                                key={rooms}
                                type={type}
                            />

                    })}
                </div>
            </div>
            <RangeInput
                title="Стоимость"
                name="price"
                min={priceFilter[0]}
                max={priceFilter[1]}
                register={register}
                value={price}
                metricSystem={" ₽"}
                handleInputChange={(value) => setPrice(value)}
            />
            <RangeInput
                title="Площадь"
                name="square"
                min={areaFilter[0]}
                max={areaFilter[1]}
                register={register}
                value={square}
                handleInputChange={(value) => setSquare(value)}
            />
        </form>
    )
}
